<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <DoctorQueueTable
      permission-key="radiology_patients"
      endpoint="/radiologypatients"
      action-path="/radiologyreport"
      action-label="Report"
      no-permission-text="You have no permission to View Radiology Patients"
    />
  </Layout>
</template>

<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import DoctorQueueTable from "@/components/DoctorQueueTable.vue";
import appConfig from "@/app.config";

export default {
  page: {
    title: "Radiology Patients",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, PageHeader, DoctorQueueTable },
  data() {
    return {
      title: "Radiology Patients",
      items: [{ text: "Dashboard", to: "/" }, { text: "Radiology Patients", active: true }],
    };
  },
};
</script>
